export const SIGN_IN = "SIGN_IN";
export const SIGN_OUT = "SIGN_OUT";
export const USER_NAME = "USER_NAME";
export const USER_DETAIL = "USER_DETAIL";
export const CODE_ASANA = "CODE_ASANA";
export const SIGN_OUT_OBJ = "SIGN_OUT_OBJ";
export const MESSAGE_POPUP = "MESSAGE_POPUP";
export const NEW_USER = "NEW_USER";
export const NEW_USER_DETAIL = "NEW_USER_DETAIL";
export const CHAT_ON = "CHAT_ON";
export const CHAT_OFF = "CHAT_OFF";
export const STEP_ONBOARDING = "STEP_ONBOARDING";
export const LIST_LESSONS = "LIST_LESSONS";
export const STATE_CHAT = "STATE_CHAT";
export const SELECT_OBJETIVE = "SELECT_OBJETIVE";
export const LIST_OBJETIVES = "LIST_OBJETIVES";
export const END_CHAT = "END_CHAT";
export const MESSAGE_CHAT = "MESSAGE_CHAT";
export const ON_MESSAGE = "ON_MESSAGE";
export const NUM_TASK_END = "NUM_TASK_END";
export const QUERY_DB = "QUERY_DB";
export const UTILS_USER = "UTILS_USER";
export const CONTROL_FLOW_CX = "CONTROL_FLOW_CX";








